import { ReactNode } from 'react';
import { cn } from '@anytag/shared-utils';
import { useSortableItemContext } from './SortableItemContext';

export interface SortableDragAreaProps {
  className?: string;
  children?: ReactNode;
}
export const SortableDragArea = ({ className, children }: SortableDragAreaProps) => {
  const { attributes, listeners, ref } = useSortableItemContext();

  return (
    <div className={cn('outline-none', className)} {...attributes} {...listeners} ref={ref}>
      {children}
    </div>
  );
};
